<template>
  <section class="store-info--w without-image" v-if="storeLength > 0">
    <div class="si--header">
      <div class="si--title pf-medium">{{ storeLabel }}</div>
      <!--定制sku商品:订单详情页，隐藏进入门店入口-->
      <div
        class="si--view-list"
        v-if="storeLength > 1 && !isHideListEntrance"
        @click="showStoreList"
      >
        <span v-if="isOpenReplacement || isSelfPhoto"
          >更换{{ storeLabel }}</span
        >
        <span v-else>查看全部{{ storeLength }}家门店&nbsp;</span
        ><i class="icon-arrow--r"></i>
      </div>
    </div>
    <div class="si--container">
      <div class="si--container__left">
        <a
          class="si--name elps"
          :href="'//life.cekid.com/h5/shop?businessId=' + storeInfo.businessKey"
        >
          {{ storeInfo.storeName }}
        </a>
        <div class="si--btm" @click="goMap">
          <i class="icon-position"></i>
          <div class="si--btm__ctn">
            <p class="elps">
              {{ address }}
            </p>
            <div class="si--distance" v-if="isAuthorizedPosition">
              <span>距您{{ distance }}</span>
            </div>
          </div>
        </div>
        <div
          class="si--tips"
          v-if="
            !isInOrderDetail &&
            (isOpenReplacement || isCustomisedGoods) &&
            storeLength > 1
          "
        >
          <span>*请确认服务门店，提交订单后不可变更</span>
        </div>
        <div
          class="si--tips"
          v-if="!isInOrderDetail && isSelfPhoto && storeLength > 1"
        >
          <span>*请确认拍摄门店，提交订单后不可变更</span>
        </div>
      </div>
      <a
        style="margin-top: -0.45rem"
        :href="'tel:' + storeInfo.mobile"
        @click="telClick"
      >
        <i class="icon-call"></i
      ></a>
    </div>

    <mockRouterAction
      :router-name="routerName"
      :title-from="titleFrom"
      title-to="门店列表"
      ref="mra"
    >
      <storeList
        :params="{ storeList }"
        :isOpenReplacement="isOpenReplacement"
        :isSelfPhoto="isSelfPhoto"
        :selectedStoreId="storeInfo.storeId"
        @onChange="handleStoreChange"
      ></storeList>
    </mockRouterAction>
  </section>
</template>
<script>
/**
 * 20210114 定制SKU需求订单确认页开启更换门店功能
 */
import M from '../mixin.js'
export default {
  // props: ["isOpenReplacement"],
  mixins: [M],
  inject: {
    busiTelTrackParams: {
      default: null
    }
  },
  // methods: {
  // handleStoreChange(storeInfo) {
  //   this.storeInfo = storeInfo
  //   // 订单确认页提交订单时带上pop门店信息，便于在订单详情页展示
  //   this.$emit("onStoreSelected", storeInfo);
  //   history.go(-1);
  // },
  // },
  computed: {
    /**定制sku商品:订单详情页，隐藏进入门店入口 */
    isHideListEntrance() {
      const { name: routerName } = this.$route
      return (
        (this.isCustomisedGoods || this.isSelfPhoto) &&
        routerName === 'order-detail'
      )
    }
  },
  methods: {
    telClick() {
      this.busiTelTrackParams &&
        this.$$newTrackClick({
          ...this.busiTelTrackParams,
          positionParam: {
            popid: this.storeInfo && this.storeInfo.businessKey
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped src="../../style.scss"></style>
